module.exports = __webpack_public_path__ + "static/media/activeShield.d4e8504f.svg";